
import { autorun, IReactionDisposer } from 'mobx';
import { disposeOnUnmount, observer } from 'mobx-react';
import * as React from 'react';
import { getOmnistore } from '../stores/Omnistore';

@observer export class EntityStoreLifecycle extends React.Component {
	_interval = 0

	_email = ''

	@disposeOnUnmount _autorun: IReactionDisposer | undefined = undefined

	componentDidMount() {
		const multirepo = getOmnistore().multirepo;
		multirepo.userRepo.fetch();
		multirepo.branchRepo.fetch();
		getOmnistore().entityManagerStore.subscribe('EntityStoreLifecycle', () => ['AdCountdown']);
		this._interval = window.setInterval(() => {
			getOmnistore().entityManagerStore.step();
		}, 123);
		this._autorun = autorun(() => {
			if (getOmnistore().authStore.email === this._email) return;
			if (this._email) getOmnistore().entityManagerStore.clear();
			this._email = getOmnistore().authStore.email;
		});
	}

	componentWillUnmount() {
		getOmnistore().entityManagerStore.unsubscribe('EntityStoreLifecycle');
		window.clearInterval(this._interval);
	}

	render() {
		return null;
	}
}
